import { apiService } from "@/_services";
export default {
  methods: {
    async deletePrompt(ID = 0) {
      if (!ID) {
        throw Error("No ID supplied.");
      }
      let newPromise = new Promise(resolve => {
        let options = {
          title: "Deleting store",
          message:
            "Are you sure you want to <b>delete store " +
            ID +
            "?</b> This action cannot be undone.",
          confirmText: "Delete Store",
          type: "is-danger",
          hasIcon: true,
          onCancel() {
            resolve(false);
          },
          onConfirm: () => {
            this.delete(ID);
            resolve(true);
          }
        };
        this.$buefy.dialog.confirm(options);
      });
      return await newPromise;
    },

    async delete(ID = 0) {
      const loadingComp = this.$buefy.loading.open();
      let request = apiService.stores.delete(ID);
      request.then(() => {
        setTimeout(() => {
          this.$buefy.toast.open("Store deleted!");
        }, 100);
      });
      request.finally(() => {
        loadingComp.close();
      });
      return await request;
    }
  }
};
